import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import poster_img from '../../../Assets/Images/Training/Training Compendium/Fire_safety_in_Informal_settlements.jpg';

const Fire_safety_in_Informal_settlements = () => {

    return (
        <div className="mt-5">
            <h4>Fire safety in Informal settlements (InSe)</h4>

            <div className="card mt-5">
                <img
                    src={poster_img}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                
                <p><strong>Aim:</strong> To equip professionals with the skills to assess and mitigate the complex fire  risks in informal settlements by integrating fire dynamics and fire risk modeling,  policy, and community-based strategies, corroborating fire risk management and  fire risk reduction.</p>
                <p>This compendium addresses the critical fire threat in urban informal settlements,  where high density, flammable materials, and limited emergency access create a  complex and dangerous risk landscape. The document analyzes the intricate  socio-spatial factors driving this vulnerability and explores the crucial role of data driven modelling to predict fire spread and identify hotspots, enabling a proactive  approach to safety.Moving from analysis to action, it presents a comprehensive  suite of strategies for risk mitigation. These range from community-led initiatives  like awareness campaigns and promoting safer building materials to broader policy  reforms that improve infrastructure and formally integrate fire safety into urban  upgrading programs.As an essential guide for policymakers, urban planners, and  NGOs, this compendium provides a clear framework for understanding the  complexities of fire risk and implementing effective, life-saving strategies in the  world's most vulnerable communities.</p>

            </div>
        </div>
    );
};

export default Fire_safety_in_Informal_settlements;
